import classnames from "classnames";
import PropTypes from "prop-types";
import React from "react";

const TogglerContext = React.createContext();
const IsOpenContext = React.createContext();

export function W3Dropdown({ className = null, children = null }) {
  const [state, setState] = React.useState({
    isOpen: false,
  });

  const toggle = React.useCallback(() => {
    setState((state) => ({
      isOpen: !state.isOpen,
    }));
  }, []);

  return (
    <div
      className={classnames(
        className,
        "w3-dropdown-click w3-dropdown-hover w3-round",
      )}
    >
      <TogglerContext.Provider value={toggle}>
        <IsOpenContext.Provider value={state.isOpen}>
          {children}
        </IsOpenContext.Provider>
      </TogglerContext.Provider>
    </div>
  );
}

W3Dropdown.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
};

export const W3DropdownToggler = ({ as: AsComponent, ...props }) => {
  return (
    <TogglerContext.Consumer>
      {(toggle) => <AsComponent {...props} onClick={toggle} />}
    </TogglerContext.Consumer>
  );
};

W3DropdownToggler.propTypes = {
  as: PropTypes.elementType,
};

W3DropdownToggler.defaultProps = {
  as: "button",
};

export const W3DropdownContent = ({ className, ...props }) => {
  return (
    <IsOpenContext.Consumer>
      {(isOpen) => (
        <div
          className={classnames(className, "w3-dropdown-content", {
            "w3-show": isOpen,
          })}
          {...props}
        />
      )}
    </IsOpenContext.Consumer>
  );
};

W3DropdownContent.propTypes = {
  className: PropTypes.string,
};

W3DropdownContent.defaultProps = {
  className: null,
};
